import { render } from "./OrderCreateSvm.vue?vue&type=template&id=22f00f67"
import script from "./OrderCreateSvm.vue?vue&type=script&lang=js"
export * from "./OrderCreateSvm.vue?vue&type=script&lang=js"

import "./OrderCreateSvm.vue?vue&type=style&index=0&id=22f00f67&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__